import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import Form from "../../../common/form";
import { sectionCreateRequest } from "../../../../store/slices/customFieldSlice";
import AddCustomFieldSectionForm from "./AddCustomFieldSectionForm";
import { useEffect } from "react";

const AddCustomFieldSection = ({
  labels,
  parent,
  menu,
  createSection,
  customFieldSections,
  action,
  error,
  requesting,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    if (action === "section-create" && !requesting && !error) {
      navigate(menu?.to);
    }
  }, [error, action, requesting, navigate, menu]);

  const onSubmit = (values) => {
    const payload = {
      name: values.name,
      order: customFieldSections.length + 1,
    };
    createSection(payload);
  };

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "add_custom_field_section" })}
          </div>
        </div>
        <div className="edexlms-page-body">
          <Form
            submitBtn={{
              label: intl.formatMessage({
                id: "add_custom_field_section",
              }),
              onClick: onSubmit,
            }}
            cancelBtn={{
              label: intl.formatMessage({ id: "cancel" }),
              onClick: () => navigate(menu?.to),
            }}
          >
            <AddCustomFieldSectionForm />
          </Form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  customFieldSections: state?.customFields?.data || [],
  action: state?.customFields?.action,
  error: state?.customFields?.error,
  requesting: state?.customFields?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  createSection: (data) => dispatch(sectionCreateRequest(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCustomFieldSection);
